import { useEffect, useState } from "react";

const Success = ({ isOpen, onClose }) => {
    const [visible, setVisible] = useState(false);
    const [closing, setClosing] = useState(true); // İlk başda closing true olur

    useEffect(() => {
        if (isOpen) {
            setVisible(true);
            setClosing(true); // İlk başda true qoyuruq ki, animasiya düzgün işləsin

            setTimeout(() => {
                setClosing(false); // Açılma animasiyasını aktivləşdirmək üçün 10ms gecikmə
            }, 10);

            // 3 saniyə sonra modal bağlanma animasiyasına başlasın
            const timer = setTimeout(() => {
                setClosing(true);

                // Animasiya bitdikdən 0.3 saniyə sonra tam bağlansın
                setTimeout(() => {
                    setVisible(false);
                    onClose();
                }, 300);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [isOpen, onClose]);

    return visible ? (
        <div
            className="success-overlay"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.2s ease-in-out, opacity 0.3s ease-in-out",
                transform: closing ? "translateX(100%)" : "translateX(0)",
                opacity: closing ? "0" : "1",
            }}
        >
            <div
                className="success-content"
                style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#16C47F",
                    padding: "20px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    width: "20vw",
                    height: "2vw",
                    position: "relative",
                    top: "20vw",
                    left: "37vw",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1vw",
                        fontSize: "0.9vw",
                        color: "white",
                    }}
                >
                    ✔<h2 style={{ color: "white" }}>Əməliyyat uğurludur!</h2>
                </div>
            </div>
        </div>
    ) : null;
};

export default Success;
